module.exports = __webpack_public_path__ + "0c4120ceee671f4dc2a7fe00375bcf7a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/donation-s.png
// module id = 1699
// module chunks = 0